import { useRef, useState } from 'react';
import { fileSize } from 'components/misc/functions';
import { HugeiconsIcon } from '@hugeicons/react';
import { AttachmentIcon, Delete02Icon } from '@hugeicons/core-free-icons';

function FormUpload({ label, name, id, setValue, required }) {
    const [file, setFile] = useState(null);
    const inputRef = useRef(null);

    const handleFileChange = (e) => {
        const selected = e.target.files[0];
        if (!selected) return;
        setFile(selected);
        setValue(selected);
    };

    const handleClear = () => {
        setFile(null);
        setValue('');
        if (inputRef.current) inputRef.current.value = '';
    };

    return (
        <div className="space-y-1.5">
            <p className="text-xs font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500">
                {label} {required && <span className="text-amber-500">*</span>}
            </p>

            {file ? (
                <div className="flex items-center gap-3 rounded-xl border border-gray-200 dark:border-white/[.08] bg-white dark:bg-gray-900 px-3 py-2.5">
                    <div className="w-8 h-8 rounded-lg bg-amber-50 dark:bg-amber-500/10 flex items-center justify-center shrink-0">
                        <HugeiconsIcon icon={AttachmentIcon} size={16} className="text-amber-600 dark:text-amber-400" />
                    </div>
                    <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-gray-800 dark:text-gray-200 truncate">{file.name}</p>
                        <p className="text-xs text-gray-400 mt-0.5">{fileSize(file.size)}</p>
                    </div>
                    <button
                        type="button"
                        onClick={handleClear}
                        className="p-1.5 rounded-lg text-gray-400 hover:text-red-500 hover:bg-red-50 dark:hover:bg-red-500/10 transition-colors shrink-0"
                        aria-label="Remove file"
                    >
                        <HugeiconsIcon icon={Delete02Icon} size={15} />
                    </button>
                </div>
            ) : (
                <label
                    htmlFor={id}
                    className="flex items-center gap-3 rounded-xl border-2 border-dashed border-gray-200 dark:border-white/[.10] bg-gray-50/50 dark:bg-white/[.02] hover:border-amber-300 dark:hover:border-amber-500/40 hover:bg-amber-50/30 dark:hover:bg-amber-500/5 transition-all px-4 py-3.5 cursor-pointer"
                >
                    <div className="w-8 h-8 rounded-lg bg-gray-100 dark:bg-gray-800 flex items-center justify-center shrink-0">
                        <HugeiconsIcon icon={AttachmentIcon} size={16} className="text-gray-400 dark:text-gray-500" />
                    </div>
                    <div>
                        <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Choose file</p>
                        <p className="text-xs text-gray-400 dark:text-gray-500 mt-0.5">PNG, JPG, PDF, DOC up to 10MB</p>
                    </div>
                </label>
            )}

            <input
                ref={inputRef}
                id={id}
                name={name}
                type="file"
                className="sr-only"
                onChange={handleFileChange}
                accept="image/*, .doc, .docx, .pdf"
                required={required && !file}
            />
        </div>
    );
}

export default FormUpload;
